import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { ItemType } from '../models/item-type';

@Injectable({
  providedIn: 'root'
})
export class ItemTypeService extends BaseService<ItemType> {
  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string    
  ) {
    super(http,rootUrl,'TimeTracking/ItemType');
  }
}
